export default __webpack_public_path__ + "static/media/watsapp.04ad8712.svg";